import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Typography } from 'seagull';
import { useNotificationParagraphs, useNotificationPreviewContext } from '../NotificationEmailPreview/NotificationEmailPreview.utils';
import { SegmentedText } from '../NotificationEmailPreview/SegmentedText';
import styles from './NotificationSmsPreview.module.scss';
import { GetNotificationSmsPreviewTID } from './NotificationSmsPreview.testIds';
export function NotificationSmsPreview(param) {
    let { message, templateVariables, customTemplateVariables, vendorBusinessName, currentDate, testId = 'notification-sms-preview' } = param;
    const { NotificationSmsPreviewTestIds: testIds } = useMemo(()=>GetNotificationSmsPreviewTID(testId), [
        testId
    ]);
    const previewContext = useNotificationPreviewContext(vendorBusinessName, currentDate);
    const paragraphs = useNotificationParagraphs(message, templateVariables, customTemplateVariables, previewContext);
    return /*#__PURE__*/ _jsx("div", {
        className: styles.root,
        "data-testid": testIds.Root(),
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.phoneFrame,
            "data-testid": testIds.PhoneFrame(),
            children: /*#__PURE__*/ _jsx("div", {
                className: styles.bubble,
                "data-testid": testIds.Bubble(),
                children: paragraphs.map((segments, index)=>/*#__PURE__*/ _jsx(Typography, {
                        as: "p",
                        variant: "paragraph2",
                        weight: "light",
                        className: styles.paragraph,
                        testId: testIds.Paragraph(index),
                        children: /*#__PURE__*/ _jsx(SegmentedText, {
                            segments: segments,
                            unresolvedTestId: testIds.UnresolvedTag
                        })
                    }, index))
            })
        })
    });
}
